module.exports = __webpack_public_path__ + "static/media/file-upload.94997847.svg";